import {
	ChangeSuggestion,
	ChangeSuggestionsResponse,
	UpdateChangeSuggestionStatusRequest,
	ZomentumEntities
} from "@/Contracts";
import axios, { AxiosResponse } from "axios";
import { getRequest, putRequest } from "../BackendService";

const getChangeSuggestionUrl = "/v2/suggestions/:id";
const getChangeSuggestionsUrl = "/v2/suggestions";
const updateChangeSuggestionUrl = "/v2/suggestions/:id";

export const getChangeSuggestion = async (
	entityId: string
): Promise<ChangeSuggestion> => {
	try {
		const response: AxiosResponse<ChangeSuggestion> = await axios(
			getRequest(
				getChangeSuggestionUrl.replace(":id", entityId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getChangeSuggestions = async (
	entityId: string,
	entityType: ZomentumEntities
): Promise<ChangeSuggestionsResponse> => {
	try {
		const response: AxiosResponse<ChangeSuggestionsResponse> = await axios(
			getRequest(
				`${getChangeSuggestionsUrl}?entity_id=${entityId}&entity_type=${entityType}`,
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateChangeSuggestionsStatus = async (
	changeSuggestionId: string,
	updateChangeSuggestionsStatusRequest: UpdateChangeSuggestionStatusRequest
): Promise<ChangeSuggestion> => {
	try {
		const response: AxiosResponse<ChangeSuggestion> = await axios(
			putRequest(
				updateChangeSuggestionUrl.replace(":id", changeSuggestionId),
				updateChangeSuggestionsStatusRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
